import { type FC } from 'react';

import { Divider } from '@/components/Divider';
import { OrderPagesButtons } from '@/components/OrderPagesButtons';
import { WithGap } from '@/components/WithGap';
import { useTexts } from '@/hooks/useTexts';

export const NoActiveOrders: FC = () => {
  const texts = useTexts();

  return (
    <WithGap gap="24" data-test="no-active-orders">
      <h2>{texts.pages.orderList.noActiveOrders.title}</h2>

      <p className="font-body">
        {texts.pages.orderList.noActiveOrders.description}
      </p>

      <WithGap gap="16">
        <p className="font-body-demibold">
          {texts.pages.orderList.noActiveOrders.addNew}
        </p>
        <OrderPagesButtons />
      </WithGap>

      <Divider size="2" />
    </WithGap>
  );
};
